(function() {
  if (window.__variantSelectorInit) return;
  window.__variantSelectorInit = true;

  console.log('[VariantSelector] Script initialisé');

  function fmt(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  // ── Met à jour le bouton ATC selon disponibilité ─────────────────────────────
  function updateAtcBtn(select) {
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var wrapper = select.closest('[data-product-id]');
    if (!wrapper) return;
    var btn = wrapper.querySelector('[data-atc-btn]');
    var label = btn && btn.querySelector('[data-atc-label]');
    if (!btn || !label) return;

    var available = opt.getAttribute('data-available') === 'true';

    btn.disabled = !available;
    label.textContent = available ? 'Ajouter au panier' : 'Épuisé';

    if (available) {
      btn.classList.remove('is-sold-out');
      select.classList.remove('is-sold-out');
    } else {
      btn.classList.add('is-sold-out');
      select.classList.add('is-sold-out');
    }
  }

  // ── Met à jour le badge de réduction ────────────────────────────────────────
  function updateBadge(select) {
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var badge = opt.getAttribute('data-discount-badge');
    var wrapper = select.closest('[data-product-id]');
    if (!wrapper) return;

    var badgeEl = wrapper.querySelector('[data-discount-badge-display]');
    if (badgeEl) {
      if (badge && badge.trim() !== '') {
        badgeEl.textContent = badge;
        badgeEl.classList.remove('is-hidden');
      } else {
        badgeEl.textContent = '';
        badgeEl.classList.add('is-hidden');
      }
    }

    var card = select.closest('product-card');
    if (card) {
      var mobileBadge = card.querySelector('.variant-selector__mobile-badge');
      if (!mobileBadge) {
        mobileBadge = document.createElement('span');
        mobileBadge.className = 'variant-selector__mobile-badge';
        var pricesDiv = card.querySelector('.prices');
        if (pricesDiv) pricesDiv.appendChild(mobileBadge);
      }
      if (badge && badge.trim() !== '') {
        mobileBadge.textContent = badge;
        mobileBadge.style.display = 'inline-block';
      } else {
        mobileBadge.style.display = 'none';
      }
    }
  }

  function initSelectors() {
    document.querySelectorAll('[data-variant-selector]').forEach(function(select) {
      updateBadge(select);
      updateAtcBtn(select);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSelectors);
  } else {
    initSelectors();
  }

  function refreshCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionId = cartDrawer && cartDrawer.dataset.sectionId;
    if (!cartDrawer || !sectionId) return Promise.resolve();

    return fetch('/cart?sections=' + sectionId)
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var html = sections[sectionId];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newItems = doc.querySelector('.cart-drawer__items');
        var currentItems = cartDrawer.querySelector('.cart-drawer__items');
        if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;

        var newHeader = doc.querySelector('.cart-drawer__header_title p');
        var currentHeader = cartDrawer.querySelector('.cart-drawer__header_title p');
        if (newHeader && currentHeader) currentHeader.innerHTML = newHeader.innerHTML;

        var newFooter = doc.querySelector('.cart-drawer__footer');
        var currentFooter = cartDrawer.querySelector('.cart-drawer__footer');
        if (newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;

        return fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var countEls = document.querySelectorAll('[data-ref="cart-count"], [data-cart-count], .cart__count, .cart-count');
            countEls.forEach(function(el) { el.textContent = cart.item_count; });
          });
      });
  }

  // ── Mise à jour du prix + badge + état épuisé au changement ─────────────────
  document.addEventListener('change', function(e) {
    if (!e.target.hasAttribute('data-variant-selector')) return;

    var select = e.target;
    var opt = select.options[select.selectedIndex];
    var price = parseInt(opt.getAttribute('data-price'));
    var comparePrice = parseInt(opt.getAttribute('data-compare-price')) || 0;

    var card = select.closest('product-card') || select.closest('[data-product-card]') || select.closest('[data-product-id]').parentElement;
    var searchRoot = card || select.closest('[data-product-id]');
    var priceEl = searchRoot.querySelector('[data-ref="price"]');
    var compareEl = searchRoot.querySelector('[data-ref="compare-at-price"]');
    var badgeEl = searchRoot.querySelector('[data-ref="difference-price-value"]');

    if (priceEl) priceEl.textContent = fmt(price);
    if (compareEl) {
      if (comparePrice > price) { compareEl.textContent = fmt(comparePrice); compareEl.style.display = ''; }
      else { compareEl.style.display = 'none'; }
    }
    if (badgeEl) badgeEl.textContent = comparePrice > price ? '-' + fmt(comparePrice - price) : '';

    updateBadge(select);
    updateAtcBtn(select);
  });

  // ── Changement de variante dans le cart drawer ───────────────────────────────
  document.addEventListener('change', function(e) {
    if (!e.target.hasAttribute('data-cart-variant-selector')) return;

    var select = e.target;
    var newVariantId = parseInt(select.value);
    var lineKey = select.getAttribute('data-line-key');

    console.log('[VariantSelector] Cart variant changé:', newVariantId, '| Clé:', lineKey);

    select.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: newVariantId, quantity: 1 })
      });
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      return refreshCartDrawer();
    })
    .catch(function(err) {
      console.error('[VariantSelector] Erreur changement variante panier:', err);
      select.disabled = false;
    });
  });

  // ── Ajout au panier ──────────────────────────────────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-atc-btn]');
    if (!btn) return;

    var wrapper = btn.closest('[data-product-id]');
    if (!wrapper) return;
    var select = wrapper.querySelector('[data-variant-selector]');
    if (!select) return;
    var variantId = parseInt(select.value);
    if (!variantId) return;

    var label = btn.querySelector('[data-atc-label]');
    var loader = btn.querySelector('[data-atc-loader]');

    if (label) label.style.display = 'none';
    if (loader) loader.style.display = 'inline-flex';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(res) {
      var status = res.status;
      return res.json().then(function(data) {
        if (status < 200 || status >= 300) throw data;
        return data;
      });
    })
    .then(function() {
      if (label) { label.textContent = '✓ Ajouté !'; label.style.display = 'inline'; }
      if (loader) loader.style.display = 'none';
      btn.classList.add('is-success');

      var cartDrawer = document.querySelector('cart-drawer');
      var sectionId = cartDrawer && cartDrawer.dataset.sectionId;

      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var countEls = document.querySelectorAll('[data-ref="cart-count"], [data-cart-count], .cart__count, .cart-count');
          countEls.forEach(function(el) { el.textContent = cart.item_count; });

          if (cartDrawer && sectionId) {
            return fetch('/cart?sections=' + sectionId)
              .then(function(r) { return r.json(); })
              .then(function(sections) {
                var html = sections[sectionId];
                if (!html) return;
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var sourceInner = doc.querySelector('cart-drawer');
                if (sourceInner) {
                  cartDrawer.innerHTML = sourceInner.innerHTML;
                  // Retire cart-drawer--empty sans toucher à is-open / is-closing
                  if (!sourceInner.classList.contains('cart-drawer--empty')) {
                    cartDrawer.classList.remove('cart-drawer--empty');
                  }
                }
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, sections: sections } }));
                if (typeof cartDrawer.open === 'function') cartDrawer.open();
                else cartDrawer.setAttribute('open', '');
              });
          }
        });

      setTimeout(function() {
        if (label) label.textContent = 'Ajouter au panier';
        btn.classList.remove('is-success');
        btn.disabled = false;
      }, 2000);
    })
    .catch(function(err) {
      var msg = (err && err.description) ? err.description : 'Erreur, réessaie';
      if (label) { label.textContent = msg; label.style.display = 'inline'; }
      if (loader) loader.style.display = 'none';
      btn.disabled = false;
      setTimeout(function() { if (label) label.textContent = 'Ajouter au panier'; }, 2500);
    });
  });

})();